import { render } from "./TelaHome.vue?vue&type=template&id=0d7147c0&scoped=true"
import script from "./TelaHome.vue?vue&type=script&lang=js"
export * from "./TelaHome.vue?vue&type=script&lang=js"

import "./TelaHome.vue?vue&type=style&index=0&id=0d7147c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7147c0"]])

export default __exports__